export default __webpack_public_path__ + "static/media/0n.3c8cbfa8.png";